import { render } from "./list-management-confirmation-dialog.vue?vue&type=template&id=701c0c54&ts=true"
import script from "./list-management-confirmation-dialog.vue?vue&type=script&lang=ts"
export * from "./list-management-confirmation-dialog.vue?vue&type=script&lang=ts"

import "./list-management-confirmation-dialog.vue?vue&type=style&index=0&id=701c0c54&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__